export default __webpack_public_path__ + "static/media/precious.cda141e3.jpeg";